import { alternative } from 'chessboard/plugins/effects/renderer/icons/alternative';
import { bestMove } from 'chessboard/plugins/effects/renderer/icons/best-move';
import { blunder } from 'chessboard/plugins/effects/renderer/icons/blunder';
import { book } from 'chessboard/plugins/effects/renderer/icons/book';
import { brilliant } from 'chessboard/plugins/effects/renderer/icons/brilliant';
import { checkmateBlack } from 'chessboard/plugins/effects/renderer/icons/checkmate-black';
import { checkmateWhite } from 'chessboard/plugins/effects/renderer/icons/checkmate-white';
import { correct } from 'chessboard/plugins/effects/renderer/icons/correct';
import { critical } from 'chessboard/plugins/effects/renderer/icons/critical';
import { defeatBlack } from 'chessboard/plugins/effects/renderer/icons/defeat-black';
import { defeatWhite } from 'chessboard/plugins/effects/renderer/icons/defeat-white';
import { drawBlack } from 'chessboard/plugins/effects/renderer/icons/draw-black';
import { drawWhite } from 'chessboard/plugins/effects/renderer/icons/draw-white';
import { excellent } from 'chessboard/plugins/effects/renderer/icons/excellent';
import { fastWin } from 'chessboard/plugins/effects/renderer/icons/fast-win';
import { freePiece } from 'chessboard/plugins/effects/renderer/icons/free-piece';
import { gamechanger } from 'chessboard/plugins/effects/renderer/icons/gamechanger';
import { greatFind } from 'chessboard/plugins/effects/renderer/icons/great-find';
import { forced } from 'chessboard/plugins/effects/renderer/icons/forced';
import { good } from 'chessboard/plugins/effects/renderer/icons/good';
import { inaccuracy } from 'chessboard/plugins/effects/renderer/icons/inaccuracy';
import { incorrect } from 'chessboard/plugins/effects/renderer/icons/incorrect';
import { mate } from 'chessboard/plugins/effects/renderer/icons/mate';
import { miss } from 'chessboard/plugins/effects/renderer/icons/miss';
import { missedWin } from 'chessboard/plugins/effects/renderer/icons/missed-win';
import { mistake } from 'chessboard/plugins/effects/renderer/icons/mistake';
import { resignBlack } from 'chessboard/plugins/effects/renderer/icons/resign-black';
import { resignWhite } from 'chessboard/plugins/effects/renderer/icons/resign-white';
import { sharp } from 'chessboard/plugins/effects/renderer/icons/sharp';
import { takeback } from 'chessboard/plugins/effects/renderer/icons/takeback';
import { threat } from 'chessboard/plugins/effects/renderer/icons/threat';
import { timeoutBlack } from 'chessboard/plugins/effects/renderer/icons/timeout-black';
import { timeoutWhite } from 'chessboard/plugins/effects/renderer/icons/timeout-white';
import { undo } from 'chessboard/plugins/effects/renderer/icons/undo';
import { winner } from 'chessboard/plugins/effects/renderer/icons/winner';
import { winnerWhite } from 'chessboard/plugins/effects/renderer/icons/winner-white';
import { interesting } from 'chessboard/plugins/effects/renderer/icons/interesting';
import { warning } from 'chessboard/plugins/effects/renderer/icons/warning';
import { equal } from 'chessboard/plugins/effects/renderer/icons/equal';
import { EffectTypes } from 'chessboard/plugins/effects/config/types';

export const EffectIcons = {
  [EffectTypes.Alternative]: alternative,
  [EffectTypes.BestMove]: bestMove,
  [EffectTypes.Blunder]: blunder,
  [EffectTypes.Book]: book,
  [EffectTypes.Brilliant]: brilliant,
  [EffectTypes.CheckmateBlack]: checkmateBlack,
  [EffectTypes.CheckmateWhite]: checkmateWhite,
  [EffectTypes.Correct]: correct,
  [EffectTypes.Critical]: critical,
  [EffectTypes.DefeatWhite]: defeatWhite,
  [EffectTypes.DefeatBlack]: defeatBlack,
  [EffectTypes.DrawBlack]: drawBlack,
  [EffectTypes.DrawWhite]: drawWhite,
  [EffectTypes.Excellent]: excellent,
  [EffectTypes.FastWin]: fastWin,
  [EffectTypes.Forced]: forced,
  [EffectTypes.FreePiece]: freePiece,
  [EffectTypes.Gamechanger]: gamechanger,
  [EffectTypes.Good]: good,
  [EffectTypes.GreatFind]: greatFind,
  [EffectTypes.Inaccuracy]: inaccuracy,
  [EffectTypes.Incorrect]: incorrect,
  [EffectTypes.Mate]: mate,
  [EffectTypes.Miss]: miss,
  [EffectTypes.MissedWin]: missedWin,
  [EffectTypes.Mistake]: mistake,
  [EffectTypes.ResignBlack]: resignBlack,
  [EffectTypes.ResignWhite]: resignWhite,
  [EffectTypes.Sharp]: sharp,
  [EffectTypes.Takeback]: takeback,
  [EffectTypes.Threat]: threat,
  [EffectTypes.TimeoutBlack]: timeoutBlack,
  [EffectTypes.TimeoutWhite]: timeoutWhite,
  [EffectTypes.Undo]: undo,
  [EffectTypes.Winner]: winner,
  [EffectTypes.WinnerWhite]: winnerWhite,
  [EffectTypes.Interesting]: interesting,
  [EffectTypes.Warning]: warning,
  [EffectTypes.Equal]: equal,
};
